import React from "react";

function Section_2() {
  return (
    <>
      <section className="csrd-landing-page-section-2-container">
        <div className="csrd-landing-page-section-2-inner-container">
          <div className="csrd-landing-page-section-2-left-section">
            <div className="csrd-landing-page-section-2-image-container">
              <img
                src={require("../../../assets/landing/csrd_landing/section-2-image.svg")}
                className="csrd-landing-page-section-2-image"></img>
            </div>
            <div className="csrd-landing-page-section-2-image-full-form-container">
              <div
                className="csrd-text"
                data-aos="fade-left"
                data-aos-delay="100"
                data-aos-duration="700"
                data-aos-once="true">
                orporate
              </div>
              <div
                className="csrd-text"
                data-aos="fade-left"
                data-aos-delay="100"
                data-aos-duration="700"
                data-aos-once="true">
                ustainability
              </div>
              <div
                className="csrd-text"
                data-aos="fade-left"
                data-aos-delay="100"
                data-aos-duration="700"
                data-aos-once="true">
                eport
              </div>
              <div
                className="csrd-text"
                data-aos="fade-left"
                data-aos-delay="100"
                data-aos-duration="700"
                data-aos-once="true">
                irective
              </div>
            </div>
          </div>
          <div className="csrd-landing-page-section-2-right-section">
            <div className="csrd-landing-page-section-2-right-header">why updapt csrd?</div>
            <div
              className="csrd-landing-page-section-2-right-description"
              data-aos="fade-left"
              data-aos-delay="100"
              data-aos-duration="700"
              data-aos-once="true">
              Updapt’s CSRD Compliance Solution is designed to simplify sustainability reporting
              through AI-powered automation, seamless data integration, and regulatory compliance
              support, reducing the burden of manual data entry and complex disclosures.
            </div>
          </div>
        </div>
      </section>
      <section
        className="csrd-landing-page-section-2-footer"
        data-aos="fade-up"
        data-aos-delay="100"
        data-aos-duration="700"
        data-aos-once="true">
        Updapt CSRD Reporting, Analytics & Management Software 
      </section>
    </>
  );
}

export default Section_2;
